<template>
  <div class="create-reservation">
    <section class="resort-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 hotel-logo">
            <img src="../../assets/images/diplomat_logo.png" alt="logo hotel" />
            <h3 class="resort-title" v-html="locationDetails.name"></h3>
          </div>
          <!-- end .col-lg-12 -->
        </div>
        <!-- end .row -->
      </div>
      <!-- end .container -->
    </section>
    <!-- ///////////////////// -->
    <!-- // POOL MAPS -->
    <!-- ///////////////////// -->
    <!-- <section id="reservation-map" v-if="locationDetails">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h3 style="margin-bottom: 25px; text-align: center;">Select Your Cabana, Daybed, or Lounge Chair</h3>
            <el-carousel :autoplay="false" indicator-position="outside">
              <el-carousel-item v-for="(item, index) in pools" :key="index">
                <img :src="item.image" style="width: 100%; height: 100%">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </section> -->

    <section id="reservation-form">
      <div v-loading="loading">
        <!-- /////////////////////////////////// -->
        <!-- // STEP 1 -->
        <!-- /////////////////////////////////// -->
        <el-card v-if="step === 1" class="box-card">
          <!-- <h3 class="resort-title location-title">Select your location</h3> -->
          <div class="available-text" style="font-size: 20px; margin-bottom: 30px">
            Click on your preferred location(s)
          </div>
          <googlemaps-map
            ref="map"
            :center.sync="mapCenter"
            :zoom.sync="mapZoom"
            :options.sync="mapOptions"
            :heading.sync="mapHeading"
            :tilt.sync="mapTilt"
            class="googleMap"
          >
            <!-- <googlemaps-marker v-for="(m, index) in markers" :key="index" :position="m.position" @click="mapMarkerMouseover(m)" :icon="m.icon">
              <el-tooltip :content="m.tooltip" class="item" effect="dark" placement="top">
                <el-button   :class="mapMarkerButton(m)" type="default" circle>{{ m.seat_no }}</el-button>
              </el-tooltip>
            </googlemaps-marker> -->

            <gmap-custom-marker
              v-for="(m, index) in markers"
              :key="index"
              :position="m.position"
              :z-index="index"
              class="map-marker"
            >
              <el-tooltip
                :content="m.tooltip"
                class="item"
                effect="dark"
                placement="top"
              >
                <el-button
                  :class="mapMarkerClass(m)"
                  type="default"
                  @click="mapMarkerClick(m)"
                  >{{ m.seat_no }}</el-button
                >
              </el-tooltip>
            </gmap-custom-marker>
          </googlemaps-map>

          <div style="margin-top: 20px; text-align: right">
            <el-button type="info" @click="handleMarkerSelected(true)">Back</el-button>
            <el-button type="primary" @click="handleMarkerSelected(false)" :disabled="selectedSeats && selectedSeats.length < 1">Continue</el-button>
          </div>
        </el-card><br />

        <el-form
          id="postForm"
          ref="postForm"
          :model="postForm"
          :rules="rules"
        >
          <!-- /////////////////////////////////// -->
          <!-- // STEP 2 -->
          <!-- /////////////////////////////////// -->
          <div v-if="step === 2">
            <el-card class="box-card">
              <!-- ///////////////// -->
              <!-- // Single/Multi dates -->
              <!-- ///////////////// -->
              <!-- <el-row :gutter="20">
                <el-col :span="10" style="text-align: right; padding-right: 20px">
                  <strong>Multiple Dates</strong>
                </el-col>
                <el-col :span="3" class="swich-bar">
                  <el-switch v-model="postForm.res_date_type" @change="handleChangeResDateType" />
                </el-col>
                <el-col :span="10" style="padding-left: 20px">
                  <strong>Single Date</strong>
                </el-col> </el-row
              ><br /> -->

              <!-- ///////////////// -->
              <!-- // Single date -->
              <!-- ///////////////// -->
              <el-row v-if="postForm.res_date_type" :gutter="20">
                <el-col :span="24">
                  <el-date-picker
                    v-model="postForm.reservation_date_single"
                    :picker-options="pickerOptions"
                    type="date"
                    format="MM/dd/yyyy"
                    placeholder="Pick any Date"
                    @change="onSingleDatePick"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>

              <!-- ///////////////// -->
              <!-- // Multiple dates -->
              <!-- ///////////////// -->
              <el-row v-if="!postForm.res_date_type" :gutter="20">
                <el-col :span="24">
                  <el-form-item
                    :error="p__errors.reservation_date"
                    label=""
                    prop="reservation_date"
                  >
                    <el-date-picker
                      v-model="postForm.reservation_date"
                      :picker-options="pickerOptions"
                      type="daterange"
                      format="MM/dd/yyyy"
                      range-separator="To"
                      start-placeholder="Select Date From"
                      end-placeholder="Select Date To"
                      @change="onMultiDatePick"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card><br />

            <!-- ///////////////// -->
            <!-- // Tabs -->
            <!-- ///////////////// -->
            <el-tabs
              v-model="editableTabsValue"
              :closable="tabClosable"
              type="border-card"
              @tab-click="tabClick"
              @edit="tabRemove"
              @tab-remove="tabRemove"
            >
              <el-tab-pane
                v-for="(tab, tabIndex) in tabs"
                :key="tabIndex"
                :label="tab.title"
                :name="tab.name"
              >
                <el-checkbox-group v-model="tab.reserved" fill="#46be8a">
                  <el-checkbox-button
                    v-for="seat in tab.seats"
                    :key="seat.id"
                    :label="seat.seat_no"
                    :checked="seat.reserved"
                    :disabled="seat.booked"
                    style="margin-left: 10px; margin-bottom: 10px"
                  >
                    <span v-if="!seat.booked" class="box-color">
                      <span class="uppercase">{{ seat.seat_type }}</span>
                      {{ seat.seat_no }}<br />
                      <strong>${{ seat.seat_price }} </strong>
                    </span>
                    <span v-if="seat.booked" class="box-color booked">
                      <span class="uppercase">{{ seat.seat_type }}</span>
                      {{ seat.seat_no }}<br />
                      <strong>${{ seat.seat_price }} </strong>
                    </span>
                  </el-checkbox-button>
                </el-checkbox-group>
              </el-tab-pane>
            </el-tabs><br />
            <div style="margin-top: 20px; text-align: right">
              <el-button type="info" @click="handleSeatSelected(true)">Back</el-button>
              <el-button type="primary" @click="handleSeatSelected(false)" :disabled="seatAmount < 1">Continue</el-button>
            </div>
          </div>

          <!-- /////////////////////////////////// -->
          <!-- // STEP 3 -->
          <!-- /////////////////////////////////// -->
          <div v-else-if="step === 3">
            <!-- <div class="col-lg-12 hotel-logo">
              <img src="../../assets/images/diplomat_logo.png" alt="logo hotel" />
              <h3 class="resort-title" v-html="locationDetails.name"></h3>
            </div> -->
            <!-- <div class="for-line"></div> -->
            <el-card class="box-card">
              <!-- Refund Within -->
              <div v-if="locationDetails.refund_within_display">
                <strong>Refund Policy</strong>
                <div class="alert alert-warning" style="margin-top: 20px">
                  Requires cancellation {{ locationDetails.refund_within_display }} prior to booking date.
                  <!-- <strong v-html="locationDetails.refund_within_display"></strong> -->
                </div>
              </div>

              <!-- Terms -->
              <div v-if="locationDetails.terms">
                <strong>Terms & Conditions</strong>
                <div class="alert alert-primary terms-editor" style="margin-top: 20px">
                  <span v-html="locationDetails.terms"/>
                </div>
              </div>
            </el-card><br />

            <el-row :gutter="20">
              <el-col :span="24">
                <!-- // Stripe Checkout Button -->
                <stripe-checkout
                  ref="stripeCheckoutRef"
                  :product="product"
                  :stripe-key="stripeKey"
                  button=""
                  button-class="btn btn-primary mt-5"
                  style="display: none"
                  on-success="broadcast"
                />
                <el-card class="box-card">
                  <el-row :gutter="20">
                    <el-col :span="12" class="input-white">
                      <el-form-item
                        :error="p__errors.first_name"
                        label="First Name"
                        prop="first_name"
                      >
                        <el-input
                          v-model="postForm.first_name"
                          type="text"
                          class="article-textarea"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="input-white">
                      <el-form-item
                        :error="p__errors.last_name"
                        label="Last Name"
                        prop="last_name"
                      >
                        <el-input
                          v-model="postForm.last_name"
                          type="text"
                          class="article-textarea"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12" class="input-white">
                      <el-form-item
                        :error="p__errors.phone_number"
                        label="Mobile Phone Number"
                        prop="phone_number"
                      >
                        <div>
                          <vue-tel-input
                            class="phoneNumber"
                            :preferred-countries="preferred_countries"
                            :only-countries="only_countries"
                            :default-country="default_country"
                            placeholder=""
                            v-model="postForm.phone_number"
                            @onInput="onInputPhone"
                            @onValidate="onValidatePhone"
                          />
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="input-white">
                      <el-form-item
                        :error="p__errors.email"
                        label="Email"
                        prop="email"
                      >
                        <el-input v-model="postForm.email" type="text" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12" class="input-white">
                      <el-form-item
                        :error="p__errors.first_name"
                        label="# Guests"
                        prop="no_of_guests"
                      >
                        <el-input
                          v-model="postForm.no_of_guests"
                          type="text"
                          class="article-textarea"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="input-white">
                      <el-form-item
                        :error="p__errors.room_no"
                        label="Room #"
                        prop="room_no"
                      >
                        <el-input
                          v-model="postForm.room_no"
                          type="text"
                          class="article-textarea"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12" class="input-white">
                      <el-form-item
                        :error="p__errors.last_name"
                        label="Requests or Notes"
                        prop="notes"
                      >
                        <el-input
                          v-model="postForm.notes"
                          type="text"
                          class="article-textarea"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card><br />

                <el-card v-if="tabs && tabs[0]" class="box-card" style="font-size: 18px;">
                  <div class="row" v-for="seatRow in tabs[0].seats">
                    <!-- {{ seatRow }} -->
                    <div v-if="tabs[0].reserved.indexOf(seatRow.seat_no) > -1" class="col-lg-12">
                      {{ seatRow.seat_label }} {{ seatRow.seat_no }}<span style="margin-left: 50px">{{ tabs[0].title }}<span v-if="tabs.length>1"> - {{ tabs[tabs.length-1].title }}</span></span> <span style="margin-left: 50px">${{ seatRow.seat_price * tabs.length }}</span> <el-button type="text" @click=handleRemoveSeat(seatRow.seat_no)><i class="el-icon-delete"></i></el-button>
                    </div>
                  </div>
                  <el-divider></el-divider>
                  <div class="row">
                    <div class="col-lg-6">
                      <!-- <div>Rental: <span v-html="seatAmountDisplay"></span></div> -->
                      <!-- <div>
                        Package: <span v-html="packageAmountDisplay"></span>
                      </div> -->
                      <div>
                        Service Fee: <span v-html="serviceFeeAmountDisplay"></span>
                        <el-tooltip placement="top">
                          <div slot="content">
                            This fee is for the staff that sets up the cabana with
                            towels.
                          </div>
                          <i class="el-icon-question" />
                        </el-tooltip>
                      </div>
                      <div>Tax: <span v-html="taxAmountDisplay"></span></div>
                      <div>Total: <span v-html="amountDisplay"></span></div>
                    </div>
                    <div class="col-lg-6 amount-display">
                      <div
                        v-if="
                          websiteCommissionPercent > 0 &&
                          websiteCommissionPercent < 100
                        "
                      >
                        Deposit Amount ({{ websiteCommissionPercent }}%):
                        <span v-html="depositAmountDisplay"></span>
                      </div>
                      <div
                        v-if="
                          websiteCommissionPercent > 0 &&
                          websiteCommissionPercent < 100
                        "
                      >
                        Balance Due at Check In:
                        <span v-html="dueAmountDisplay"></span>
                      </div>
                    </div>
                  </div>
                </el-card><br />

                <div class="text-right">
                  <el-button type="info" @click="submitForm(true)">Back</el-button>

                  <!-- // Reserve Pay Now -->
                  <el-button
                    v-if="depositAmount > 0"
                    type="primary"
                    @click="submitForm(false)"
                    class="btn btn-success"
                    >Pay Now {{ depositAmountDisplay }}</el-button
                  >

                  <el-button
                    v-if="depositAmount < 1"
                    type="primary"
                    @click="submitForm(false)"
                    class="btn btn-success"
                    >Submit Reservation</el-button
                  >
                </div>
              </el-col>
            </el-row><br />
          </div>
        </el-form>
      </div>
      <!-- end .container -->
    </section>
  </div>
</template>
<script>
import { getLocationDetails } from "@/api/location";
import {
  store,
  getAvailableSeats,
  confirmReservation,
  sendConfirmReservationEmail,
} from "@/api/reservation";
import { StripeCheckout, Bus } from "vue-stripe";
import VueTelInput from "vue-tel-input";
import moment from "moment";
import GmapCustomMarker from "./gmap-custom-marker";

/**
 * Form model initiated with the default value
 *
 */
const defaultForm = {
  res_date_type: false,
  reservation_date_single: "",
  reservation_date: [],
  first_name: "",
  last_name: "",
  phone_number: "",
  email: "",
  no_of_guests: "",
  room_no: "",
  notes: "",
};

export default {
  name: "Reservation",
  components: {
    VueTelInput,
    "stripe-checkout": StripeCheckout,
    "gmap-custom-marker": GmapCustomMarker,
  },
  data() {
    return {
      mapCenter: {
        lat: 0,
        lng: 0,
      },
      mapZoom: 19,
      mapHeading: 0,
      mapTilt: 45,
      mapOptions: {
        mapTypeId: "satellite",
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      markers: [],
      selectedSeats: [],

      loading: false,
      stripeKey:
        location.hostname === "localhost"
          ? "pk_test_fc67NomR6eUQitooVAXpZrNp"
          : "pk_live_0nk6AdQcUZD6P68w4ud9SwAh",
      product: {
        name: "Reservation",
        description: "Reservation Confirmation",
        amount: 0,
      },

      step: 1,
      reservationId: "",
      locationId: "",
      locationDetails: "",
      seatTypeOptionId: "",
      pools: [],
      p__errors: {},
      postForm: Object.assign({}, defaultForm),
      rules: {
        reservation_date: {
          required: true,
          message: "Please enter reservation date.",
          trigger: "blur",
        },
        first_name: {
          required: true,
          message: "Please enter your first name.",
          trigger: "blur",
        },
        last_name: {
          required: true,
          message: "Please enter your last name.",
          trigger: "blur",
        },
        phone_number: {
          required: true,
          message: "Please enter your phone number.",
          trigger: "blur",
        },
        email: {
          required: false,
          message: "Please enter your email.",
          trigger: "blur",
        },
      },
      dateFrom: "",
      dateTo: "",
      tabs: [],
      activeTabName: "",
      tabClosable: false,
      editableTabsValue: "",
      pickerOptions: {
        disabledDate(date) {
          const dated = moment(new Date()).format("YYYY-MM-DD");
          const comapare = moment(new Date(date)).format("YYYY-MM-DD");
          return new Date(dated) > new Date(comapare);
        },
      },

      locationTimezoneId: "",

      tax: 0,
      serviceFee: 0,
      serviceFeeTaxOn: 0,
      websiteCommissionPercent: 0,

      seatAmount: 0,
      seatAmountDisplay: "",
      packageAmount: 0,
      packageAmountDisplay: "",
      serviceFeeAmount: 0,
      serviceFeeAmountDisplay: "",
      amount: 0,
      amountDisplay: 0,
      taxAmount: 0,
      taxAmountDisplay: "",
      commissionAmount: 0,
      commissionAmountDisplay: "",
      commissionAmount: 0,
      commissionAmountDisplay: "",
      depositAmount: 0,
      depositAmountDisplay: "",
      dueAmount: 0,
      dueAmountDisplay: "",
    };
  },

  watch: {
    tabs: {
      handler(tabs) {
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        // FOR MAP WE CAN DO ONLY FIRST DAY
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        this.markers.forEach((m, seatIndex) => {
          this.markers[seatIndex].selected = false;
        });

        // seat amount
        let totalSeatPrice = 0;
        let totalPackagePrice = 0;
        this.tabs.forEach((tab, tabIndex) => {
          tab.seats.forEach((seat, seatIndex) => {
            seat.tax_amount = 0;
            seat.service_fee_amount = 0;
            if (tab.reserved.indexOf(seat.seat_no) > -1) {
              seat.service_fee_amount =
                seat.seat_price * (this.serviceFee / 100);
              if (this.serviceFeeTaxOn == 1) {
                seat.tax_amount =
                  (seat.seat_price + seat.service_fee_amount) *
                  (this.tax / 100);
              } else {
                seat.tax_amount = seat.seat_price * (this.tax / 100);
              }
              totalSeatPrice = totalSeatPrice + seat.seat_price;
              // seat.food_packages.forEach((food, index) => {
              //   food.tax_amount = 0
              //   food.service_fee_amount = 0
              //   if(food.checked) {
              //     food.tax_amount           =  (food.rate * food.qty) * (this.tax/100);
              //     if(this.serviceFeeTaxOn == 1) {
              //       food.service_fee_amount =  (food.rate * food.qty) * (this.serviceFee/100);
              //     }else{
              //       food.service_fee_amount =  0;
              //     }
              //     totalPackagePrice = totalPackagePrice + (food.rate * food.qty);
              //   }
              // });

              // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
              // FOR MAP WE CAN DO ONLY FIRST DAY
              // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
              // if (tabIndex === 0) {
                this.markers[seatIndex].selected = true;
              // }
            }
          });
        });

        // seat amount
        this.seatAmount = this.priceOnly(totalSeatPrice);
        this.seatAmountDisplay = this.formatPrice(totalSeatPrice, "$");

        // package amount
        this.packageAmount = this.priceOnly(totalPackagePrice);
        this.packageAmountDisplay = this.formatPrice(totalPackagePrice, "$");

        // service fees
        this.serviceFeeAmount = this.calculateReservationServiceFee(
          this.seatAmount + this.packageAmount,
          this.serviceFee
        );
        this.serviceFeeAmountDisplay = this.formatPrice(
          this.serviceFeeAmount,
          "$"
        );

        this.amount = this.priceOnly(
          this.seatAmount + this.packageAmount + this.serviceFeeAmount
        );

        let taxableAmount =
          this.serviceFeeTaxOn === 1
            ? this.amount
            : this.amount - this.serviceFeeAmount;

        // tax
        this.taxAmount = this.priceOnly((taxableAmount * this.tax) / 100);
        this.taxAmountDisplay = this.formatPrice(this.taxAmount, "$");

        // total amount
        this.amount = this.priceOnly(this.amount + this.taxAmount);
        this.amountDisplay = this.formatPrice(this.amount, "$");

        // total commission amount
        // this.commissionAmount = this.priceOnly((this.amount * this.reservationCommission)/100)
        // this.commissionAmountDisplay = this.formatPrice(this.commissionAmount, '$');

        // total deposit amount
        // this.depositAmount = this.priceOnly((this.amount * this.websiteCommissionPercent)/100)
        this.depositAmount = this.calculateReservationCommissionAmount(
          totalSeatPrice,
          this.reservationCommission,
          this.reservationCommissionType
        );
        this.product.amount = this.depositAmount * 100; // convert to cents
        this.depositAmountDisplay = this.formatPrice(this.depositAmount, "$");

        // total due amount
        this.dueAmount =
          this.priceOnly(this.amount) - this.priceOnly(this.depositAmount);
        this.dueAmountDisplay = this.formatPrice(this.dueAmount, "$");
      },
      deep: true,
    },
  },

  created() {
    this.loading = true;
    this.dateFrom = this.$route.query.date_from;
    this.dateTo = this.$route.query.date_to;
    this.locationSlug = this.$route.params.slug;
    this.seatTypeOptionId = this.$route.query.seat_type_option_id;

    // if (this.dateFrom) {
    //   // for single
    //   this.postForm.reservation_date_single = moment(this.dateFrom).format(
    //     "YYYY-MM-DD hh:mm:ss"
    //   );
    //
    //   // for multiple
    //   this.postForm.reservation_date = [
    //     moment(this.dateFrom).format("YYYY-MM-DD hh:mm:ss"),
    //     moment(this.dateFrom).format("YYYY-MM-DD hh:mm:ss"),
    //   ];
    // }

    if (this.dateFrom) {
      this.dateFrom = moment(this.dateFrom, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss");
    }

    if (this.dateTo) {
      this.dateTo = moment(this.dateTo, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss");
    }

    // for multiple
    this.postForm.reservation_date = [
      moment(this.dateFrom).format("YYYY-MM-DD hh:mm:ss"),
      moment(this.dateTo).format("YYYY-MM-DD hh:mm:ss"),
    ];

    getLocationDetails(this.locationSlug, this.dateFrom, this.dateTo).then((response) => {
      if (response.data.success == true) {
        this.locationDetails = response.data.data.locations[0];
        this.pools = response.data.data.pools;
        this.locationId = this.locationDetails.id;
        this.tax = this.locationDetails.tax;
        this.serviceFee = this.locationDetails.service_fee;
        this.serviceFeeTaxOn = this.locationDetails.service_fee_tax_on;
        this.websiteCommissionPercent =
          this.locationDetails.website_commission_percent;
        this.reservationCommission =
          this.locationDetails.reservation_commission;
        this.reservationCommissionType =
          this.locationDetails.reservation_commission_type;
        this.locationTimezoneId = this.locationDetails.timezone_id;
        this.initMapMarker();
        this.onMultiDatePick([this.dateFrom, this.dateTo]);
      }
      this.loading = false;
    });

    // After payment success
    Bus.$on("vue-stripe.success", (payload) => {
      this.loading = true;
      let tokenId = payload.token;

      // stripe payment fields
      this.postForm = {};
      this.postForm.reservation_id = this.reservationId;
      this.postForm.token_id = tokenId;
      this.postForm.payment_mode = "card";
      this.postForm.currency = "usd";
      this.postForm.deposit_amount = this.depositAmount;

      // post form with data
      confirmReservation(this.postForm)
        .then((response) => {
          if (response.data.success === true) {
            // this.flashSuccess(response.data.message)
            // this.$router.push('/reservations/success/' + this.reservationId)
            this.$router.push(
              "/reservations/confirmation/" + this.reservationId
            );
          } else {
            this.validationErrors(response.data.message);
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  methods: {
    handleChangeResDateType(arg) {
      if (arg == true) {
        this.onSingleDatePick(this.postForm.reservation_date_single);
      } else {
        this.onMultiDatePick(this.postForm.reservation_date);
      }
    },
    initMapMarker() {
      const latLng = {
        lat: parseFloat(this.locationDetails.latitude),
        lng: parseFloat(this.locationDetails.longitude),
      };
      this.mapCenter = latLng;
    },
    showMapMarkers(seats) {
      // seats
      if (seats) {
        const map = this.$refs.map.$_map;
        // const bounds = new google.maps.LatLngBounds()
        const bounds = new window.google.maps.LatLngBounds();
        // const bounds = this.$refs.map.$mapObject.getBounds()
        this.mapHeading = 270;
        this.mapTilt = 45;
        seats.forEach((seat, seatIndex) => {
          if (seat.seat_latitude && seat.seat_longitude) {
            const latLng = {
              lat: parseFloat(seat.seat_latitude),
              lng: parseFloat(seat.seat_longitude),
            };
            // const label = {
            //   color: 'black',
            //   fontFamily: 'Material Icons',
            //   fontSize: '20px',
            //   text: 'A',
            // }
            // const icon = {
            //   url : "",
            //   scaledSize: new google.maps.Size(20, 20)
            // }
            this.markers.push({
              position: latLng,
              seat_no: seat.seat_no,
              tooltip:
                seat.seat_label +
                " " +
                seat.seat_no +
                " | " +
                seat.seat_price_display,
              booked: seat.booked,
              selected: false,
            });
            bounds.extend(latLng);
          }
        });
        setTimeout(() => {
          map.fitBounds(bounds);
        }, 100);
      }
    },
    mapMarkerClass(m) {
      if (!m.booked && !m.selected) {
        return "default-color";
      } else if (m.booked && !m.checked_in) {
        return "default-color booked";
      } else if (m.booked && m.checked_in && m.reservation_date_id) {
        return "default-color booked";
      } else if (m.selected) {
        return "default-color selected";
      }
    },
    mapMarkerClick(m) {
      m.selected = !m.selected;

      // // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      // // FOR MAP WE CAN DO ONLY FIRST DAY
      // // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      // if (m.selected) {
      //   this.tabs[0].reserved.push(m.seat_no);
      // } else {
      //   var index = this.tabs[0].reserved.indexOf(m.seat_no);
      //   if (index > -1) {
      //     this.tabs[0].reserved.splice(index, 1);
      //   }
      // }

      this.tabs.forEach((tab, tabIndex) => {
        if (m.selected) {
          tab.reserved.push(m.seat_no);
        } else {
          var index = tab.reserved.indexOf(m.seat_no);
          if (index > -1) {
            tab.reserved.splice(index, 1);
          }
        }
        this.selectedSeats = tab.reserved;
      });
    },
    handleRemoveSeat(seatNo) {
      this.$confirm('Are you sure, want to remove?', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          this.tabs.forEach((tab, tabIndex) => {
            var index = tab.reserved.indexOf(seatNo);
            if (index > -1) {
              tab.reserved.splice(index, 1);
            }
            this.selectedSeats = tab.reserved;
          });
        }).catch(() => {

        });
    },
    handleMarkerSelected(isBack) {
      if (isBack) {
        this.$router.push(
          "/locations/" +
            this.locationSlug +
            "?" +
            "&date_from=" + moment(this.dateFrom, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss") +
            "&date_to=" + moment(this.dateTo, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss")
        );
      } else {
        this.step = 3;
      }
    },
    handleSeatSelected(isBack) {
      if (isBack) {
        this.step = 1;
      } else {
        this.step = 3;
      }
    },
    submitForm(isBack) {
      if (isBack) {
        this.step = 1;
      } else {
        this.loading = true;
        this.$refs.postForm.validate((valid) => {
          if (valid) {
            this.postForm.date_from = this.dateFrom;
            this.postForm.date_to = this.dateTo;
            this.postForm.location_id = this.locationId;
            this.postForm.tabs = this.tabs;
            this.postForm.service_fee_amount = this.serviceFeeAmount;
            this.postForm.deposit_amount = this.depositAmount;
            this.postForm.timezone_id = this.locationTimezoneId;

            // post form with data
            store(this.postForm)
              .then((response) => {
                if (response.data.success === true) {
                  this.reservationId = response.data.data.id;
                  if (this.depositAmount > 0) {
                    this.$refs.stripeCheckoutRef.purchase();
                  } else {
                    sendConfirmReservationEmail(response.data.data.id)
                      .then((response) => {})
                      .catch((err) => {
                        console.log(err);
                      });
                    this.$router.push(
                      "/reservations/confirmation/" + response.data.data.id
                    );
                  }
                  // if (this.websiteCommissionPercent > 0) {
                  //   this.$refs.stripeCheckoutRef.purchase()
                  // } else {
                  //   sendConfirmReservationEmail(response.data.data.id).then(response => {
                  //   }).catch(err => {
                  //     console.log(err)
                  //   })
                  //   this.$router.push('/reservations/confirmation/' + response.data.data.id)
                  // }
                } else {
                  this.validationErrors(response.data.message);
                }
                this.loading = false;
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.loading = false;
            this.validationScrollTo("#postForm");
            return false;
          }
        });
      }
    },

    /*
     * Add tab
     */
    addTab(tab) {
      this.tabs.push({
        title: tab.date,
        name: tab.date,
        seats: tab.seats,
        reserved: [],
        from_date_time: tab.from_date_time,
        to_date_time: tab.to_date_time,
        content: "New Tab content",
      });
      this.editableTabsValue = tab.date;
    },

    /*
     * Click tab
     */
    tabClick(tab) {
      const tabId = tab.name;
      this.activeTabName = tabId;
    },

    /*
     * Click tab
     */
    tabRemove(val) {
      console.log(val);
    },

    generateRequestData(formsData) {
      const data = {};
      _.each(formsData, (element, index) => {
        if (
          this.postForm.hasOwnProperty(index) &&
          index === "link" &&
          element !== ""
        ) {
          data[index] = `http://${element}`;
        } else {
          data[index] = element;
        }
      });
      return data;
    },

    onSingleDatePick(date) {
      this.postForm.reservation_date = [
        moment(date).format("YYYY-MM-DD hh:mm:ss"),
        moment(date).format("YYYY-MM-DD hh:mm:ss"),
      ];
      this.onMultiDatePick([date, date]);
    },

    onMultiDatePick(range) {
      this.loading = true;
      this.tabs = [];
      var firstRange = moment(range[0]);
      var lastRange = moment(range[1]);
      var diffInDay = lastRange.diff(firstRange, 'days') + 1;
      const dates = [];
      if (diffInDay > 0) {
        for (let i = 0; i < diffInDay; i++) {
          const today = moment(firstRange).add(i, 'days');
          const formatedDate = today.format('YYYY-MM-DD');
          dates.push(formatedDate);
        }
      }
      let locationId = this.locationId;
      this.loading = false;
      getAvailableSeats(locationId, dates, this.locationTimezoneId, this.seatTypeOptionId)
        .then((response) => {
          let tabs = response.data.data.seats;
          tabs.forEach((item, index) => {
            this.addTab(item);
          });
          this.activeTabName = tabs[0].date;
          this.editableTabsValue = this.activeTabName;

          // show seat markers
          this.showMapMarkers(tabs[0].seats);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.hotel-logo {
  display: flex;
  align-items: center;
  img {
    width: 70px;
    @media only screen and (max-width: 480px) {
      width: 50px;
    }
  }
  h3{
    margin:0px !important;
  }
}
.for-line{
  width: 100%;
  border: 1px solid #dcdfe6;
  margin: 10px 0 20px;
}
#postForm {
  width: 60%;
  margin: 0 auto;
  @media only screen and (max-width: 1000px) {
    width: 100%;
    padding: 0 10px;
  }
}
.googleMap {
  height: calc(100vh - 212px);
  width: 100%;
}
.container {
  margin-top: 20px;
}
.swich-bar {
  display: flex;
  justify-content: center;
}
.resort-title {
  margin: 0 0 1rem 0 !important;
}
.input-white {
  @media only screen and (max-width: 520px) {
    width: 100%;
  }
}

.phoneNumber {
    ul {
      top:53px;
      width: unset !important;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?533f3459